import Vue from 'vue';
import ElementUI from 'element-ui';
import '@/assets/styles/element-variables.scss';
import App from './App.vue';
import router from './router';
import store from './store';
import './filters';
import TrackerPlugin, { initTracker, setupRouterTrack } from '@/tracker';
// 进度条样式
import 'nprogress/nprogress.css';

Vue.use(ElementUI);
Vue.use(TrackerPlugin);

Vue.config.productionTip = false;
Vue.config.devtools = true;

setupRouterTrack(router);
initTracker({ router });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
